const userList = [
  {
    field: 'lastName',
    headerName: 'LastName',
    width: 100,
    align: 'left'
  },
  {
    field: 'firstName',
    headerName: 'FirstName',
    width: 100,
    editable: false,
    align: 'left'
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 240,
    editable: false,
    align: 'left',
    renderCell: (params) => {
      return (
        <div
          style={{
            width: '50',
            display: 'inline-block',
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            textAlign: 'left'
          }}
        >
          {params.value}
        </div>
      );
    }
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 110,
    editable: false,
    align: 'left'
  },
  {
    field: 'isAdmin',
    headerName: 'IsAdmin',
    width: 70,
    editable: false,
    align: 'left',
    renderCell: (params) => {
      switch (params.value) {
        case true:
          params.value = 'Yes';
          break;
        case false:
          params.value = 'No';
          break;
        default:
          break;
      }
      return params.value;
    }
  },
  {
    field: 'expertModeAllowed',
    headerName: 'ExpertModeAllowed',
    width: 125,
    editable: false,
    align: 'left',
    renderCell: (params) => {
      switch (params.value) {
        case true:
          params.value = 'Yes';
          break;
        case false:
          params.value = 'No';
          break;
        default:
          break;
      }
      return params.value;
    }
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 70,
    editable: false,
    align: 'left'
  },
  {
    field: 'defaultLanguage',
    headerName: 'DefaultLanguage',
    width: 120,
    editable: false,
    align: 'left'
  },
  {
    field: 'plant',
    headerName: 'Plant',
    width: 70,
    editable: false,
    align: 'left'
  },
  {
    field: 'unitSystem',
    headerName: 'UnitSystem',
    width: 100,
    editable: false,
    align: 'left',
    renderCell: (params) => {
      switch (params.value) {
        case 'si':
          params.value = 'SI';
          break;
        case 'us':
          params.value = 'US';
          break;
        case 'cu':
          params.value = 'Custom';
          break;
        default:
          break;
      }
      return params.value;
    }
  }
];

export { userList };
